// Suspensão de venda (30/09/2026): com VITE_VENDA_SUSPENSA=1 nenhuma entrada de venda abre o fluxo.
export const isVendaSuspensa = (valor) => String(valor ?? '').trim() === '1'

export const AVISO_VENDA_SUSPENSA = {
    titulo: 'Venda online suspensa no momento.',
    contato: 'Fale com a KSK:',
    email: 'atendimento@ksk.com.br',
    telefone: '(11) 3410-8100',
    whatsapp: '(11) 96658-5551',
    hrefEmail: 'mailto:atendimento@ksk.com.br',
    hrefTelefone: 'tel:+551134108100',
    hrefWhatsapp: 'https://wa.me/5511966585551',
    horario: 'Segunda a sexta, das 8h às 18h.',
}

// Ponto comum: suspenso mostra o aviso e NÃO chama o fluxo; ligado, abre o fluxo normal.
export function guardaVenda(suspensa, abrirFluxo, mostrarAviso) {
    if (suspensa) {
        mostrarAviso()
        return false
    }
    abrirFluxo()
    return true
}
